// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { InferrexClient } from '@inferrex/sdk';
import { getClient, idempotencyKeyFor, type MutationRequestOptions } from './client-runtime.js';

// 495 hooks generated from route-definitions over the typed SDK.

export function useGetQueueTelemetry() {
  return useQuery({
    queryKey: ['admin', 'queue-telemetry'],
    queryFn: () => getClient().admin.getQueueTelemetry(),
  });
}

export function useIssueLicence(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['issueLicence']>[0]) => getClient().admin.issueLicence(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useActivateRuntimeRoute(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['activateRuntimeRoute']>[0]) => getClient().admin.activateRuntimeRoute(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useDeactivateRuntimeRoute(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['deactivateRuntimeRoute']>[0]) => getClient().admin.deactivateRuntimeRoute(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useActivateRuntimeTable(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['activateRuntimeTable']>[0]) => getClient().admin.activateRuntimeTable(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useDeactivateRuntimeTable(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['deactivateRuntimeTable']>[0]) => getClient().admin.deactivateRuntimeTable(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useActivateRuntimePage(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['activateRuntimePage']>[0]) => getClient().admin.activateRuntimePage(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useDeactivateRuntimePage(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['deactivateRuntimePage']>[0]) => getClient().admin.deactivateRuntimePage(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useListRuntimeNav(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['platform', 'manifests', 'nav', options ?? {}],
    queryFn: () => getClient().platform.listRuntimeNav(options),
  });
}

export function useListRuntimePageManifests(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['platform', 'manifests', 'pages', options ?? {}],
    queryFn: () => getClient().platform.listRuntimePageManifests(options),
  });
}

export function useGetRuntimePageManifest(id: string) {
  return useQuery({
    queryKey: ['platform', 'manifests', 'pages', id],
    queryFn: () => getClient().platform.getRuntimePageManifest(id),
    enabled: !!id,
  });
}

export function useListRuntimeDashboards() {
  return useQuery({
    queryKey: ['platform', 'manifests', 'dashboards'],
    queryFn: () => getClient().platform.listRuntimeDashboards(),
  });
}

export function useWithdrawPersonalSecret(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['withdrawPersonalSecret']>[0]) => getClient().admin.withdrawPersonalSecret(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useOffboardWorkspaceUser(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['offboardWorkspaceUser']>[0]) => getClient().admin.offboardWorkspaceUser(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useWithdrawOwnTenantSecret(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['withdrawOwnTenantSecret']>[0]) => getClient().core.withdrawOwnTenantSecret(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useOffboardOwnWorkspaceUser(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['offboardOwnWorkspaceUser']>[0]) => getClient().core.offboardOwnWorkspaceUser(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useAnonymiseWorkspaceUser(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['anonymiseWorkspaceUser']>[0]) => getClient().core.anonymiseWorkspaceUser(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useShareOwnSecret(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['shareOwnSecret']>[0]) => getClient().core.shareOwnSecret(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useUnshareOwnSecret(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['unshareOwnSecret']>[0]) => getClient().core.unshareOwnSecret(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useListCliSnippets() {
  return useQuery({
    queryKey: ['cli-snippets'],
    queryFn: () => getClient().cli_snippets.listCliSnippets(),
  });
}

export function useCreateCliSnippet(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['cli_snippets']['createCliSnippet']>[0]) => getClient().cli_snippets.createCliSnippet(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli_snippets'] });
    },
  });
}

export function useUpdateCliSnippet(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['cli_snippets']['updateCliSnippet']>[0]; request: Parameters<InferrexClient['cli_snippets']['updateCliSnippet']>[1] }) => getClient().cli_snippets.updateCliSnippet(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli_snippets'] });
    },
  });
}

export function useDeleteCliSnippet(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['cli_snippets']['deleteCliSnippet']>[0]) => getClient().cli_snippets.deleteCliSnippet(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli_snippets'] });
    },
  });
}

export function useStartScraper(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['startScraper']>[0]) => getClient().admin.startScraper(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useSubmitTraining(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['submitTraining']>[0]) => getClient().admin.submitTraining(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useListAiValidation(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'ai-validation', options ?? {}],
    queryFn: () => getClient().admin.listAiValidation(options),
  });
}

export function useStartAiValidation(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['startAiValidation']>[0]) => getClient().admin.startAiValidation(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useGetScraperJobStatus(id: string) {
  return useQuery({
    queryKey: ['admin', 'scraper-jobs', id, 'status'],
    queryFn: () => getClient().admin.getScraperJobStatus(id),
    enabled: !!id,
  });
}

export function useStartDeploy(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['startDeploy']>[0]) => getClient().admin.startDeploy(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useGetDeployJobStatus(id: string) {
  return useQuery({
    queryKey: ['admin', 'deploy-jobs', id, 'status'],
    queryFn: () => getClient().admin.getDeployJobStatus(id),
    enabled: !!id,
  });
}

export function useStartRebuildDeploy(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => getClient().admin.startRebuildDeploy({ idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function usePublishManifestEdit(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['publishManifestEdit']>[0]) => getClient().admin.publishManifestEdit(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useListManifestEdits() {
  return useQuery({
    queryKey: ['admin', 'manifest-edits'],
    queryFn: () => getClient().admin.listManifestEdits(),
  });
}

export function useListVaultSecrets() {
  return useQuery({
    queryKey: ['admin', 'vault-secrets'],
    queryFn: () => getClient().admin.listVaultSecrets(),
  });
}

export function useRotateVaultSecret(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['rotateVaultSecret']>[0]) => getClient().admin.rotateVaultSecret(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function usePropagateVaultSecret(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['propagateVaultSecret']>[0]) => getClient().admin.propagateVaultSecret(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useRollbackPlatformConfig(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['rollbackPlatformConfig']>[0]) => getClient().admin.rollbackPlatformConfig(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useDeriveTunable(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['deriveTunable']>[0]) => getClient().admin.deriveTunable(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useSetTunableChain(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['setTunableChain']>[0]) => getClient().admin.setTunableChain(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useGrantInternalAccess(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['provisioning']['grantInternalAccess']>[0]) => getClient().provisioning.grantInternalAccess(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['provisioning'] });
    },
  });
}

export function useAdminCreateTenant(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['provisioning']['adminCreateTenant']>[0]) => getClient().provisioning.adminCreateTenant(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['provisioning'] });
    },
  });
}

export function useProvisionTenantFromCompany(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['provisioning']['provisionTenantFromCompany']>[0]; request: Parameters<InferrexClient['provisioning']['provisionTenantFromCompany']>[1] }) => getClient().provisioning.provisionTenantFromCompany(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['provisioning'] });
    },
  });
}

export function useProvisionTenantFromContact(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['provisioning']['provisionTenantFromContact']>[0]; request: Parameters<InferrexClient['provisioning']['provisionTenantFromContact']>[1] }) => getClient().provisioning.provisionTenantFromContact(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['provisioning'] });
    },
  });
}

export function useAdminTenantMembers(id: string) {
  return useQuery({
    queryKey: ['admin', 'tenants', id, 'members'],
    queryFn: () => getClient().admin.adminTenantMembers(id),
    enabled: !!id,
  });
}

export function useAdminTenantEnvironments(id: string) {
  return useQuery({
    queryKey: ['admin', 'tenants', id, 'environments'],
    queryFn: () => getClient().admin.adminTenantEnvironments(id),
    enabled: !!id,
  });
}

export function useAdminTenantConnections(id: string) {
  return useQuery({
    queryKey: ['admin', 'tenants', id, 'connections'],
    queryFn: () => getClient().admin.adminTenantConnections(id),
    enabled: !!id,
  });
}

export function useAdminTenantPipelines(id: string) {
  return useQuery({
    queryKey: ['admin', 'tenants', id, 'pipelines'],
    queryFn: () => getClient().admin.adminTenantPipelines(id),
    enabled: !!id,
  });
}

export function useAdminTenantLicences(id: string) {
  return useQuery({
    queryKey: ['admin', 'tenants', id, 'licences'],
    queryFn: () => getClient().admin.adminTenantLicences(id),
    enabled: !!id,
  });
}

export function useAdminTenantUsage(id: string) {
  return useQuery({
    queryKey: ['admin', 'tenants', id, 'usage'],
    queryFn: () => getClient().admin.adminTenantUsage(id),
    enabled: !!id,
  });
}

export function useAdminTenantAuditTrail(id: string) {
  return useQuery({
    queryKey: ['admin', 'tenants', id, 'audit'],
    queryFn: () => getClient().admin.adminTenantAuditTrail(id),
    enabled: !!id,
  });
}

export function useAdminTenantSupportTickets(id: string) {
  return useQuery({
    queryKey: ['admin', 'tenants', id, 'support-tickets'],
    queryFn: () => getClient().admin.adminTenantSupportTickets(id),
    enabled: !!id,
  });
}

export function useAddTenantUser(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['provisioning']['addTenantUser']>[0]; request: Parameters<InferrexClient['provisioning']['addTenantUser']>[1] }) => getClient().provisioning.addTenantUser(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['provisioning'] });
    },
  });
}

export function useUploadLicence(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['licence']['uploadLicence']>[0]) => getClient().licence.uploadLicence(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['licence'] });
    },
  });
}

export function useValidateLicence(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['licence']['validateLicence']>[0]) => getClient().licence.validateLicence(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['licence'] });
    },
  });
}

export function useDetectAuth(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['connections']['detectAuth']>[0]) => getClient().connections.detectAuth(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useInferConnection(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['connections']['inferConnection']>[0]) => getClient().connections.inferConnection(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useEmitConnection(id: string, protocol: string) {
  return useQuery({
    queryKey: ['connections', id, 'emit', protocol],
    queryFn: () => getClient().connections.emitConnection(id, protocol),
    enabled: !!id && !!protocol,
  });
}

export function useRouteRecord(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['connections']['routeRecord']>[0]) => getClient().connections.routeRecord(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useConnections() {
  return useQuery({
    queryKey: ['connections'],
    queryFn: () => getClient().connections.listConnections().then((r) => r.connections),
  });
}

export function useConnection(id: string) {
  return useQuery({
    queryKey: ['connections', id, 'manifest'],
    queryFn: () => getClient().connections.getConnectionManifest(id),
    enabled: !!id,
  });
}

export function useUpdateConnection(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['connections']['updateConnection']>[0]; request: Parameters<InferrexClient['connections']['updateConnection']>[1] }) => getClient().connections.updateConnection(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useReinferConnection(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['connections']['reinferConnection']>[0]; request: Parameters<InferrexClient['connections']['reinferConnection']>[1] }) => getClient().connections.reinferConnection(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useDeleteConnection(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['connections']['deleteConnection']>[0]) => getClient().connections.deleteConnection(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useMatchConnections(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['connections']['matchConnections']>[0]; request: Parameters<InferrexClient['connections']['matchConnections']>[1] }) => getClient().connections.matchConnections(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useListMappings(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['mappings', options ?? {}],
    queryFn: () => getClient().mappings.listMappings(options),
  });
}

export function useListMappingTargets(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['mappings', 'targets', options ?? {}],
    queryFn: () => getClient().mappings.listMappingTargets(options),
  });
}

export function useApproveMapping(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['mappings']['approveMapping']>[0]) => getClient().mappings.approveMapping(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['mappings'] });
    },
  });
}

export function useListMappingVersions(id: string) {
  return useQuery({
    queryKey: ['mappings', id, 'versions'],
    queryFn: () => getClient().mappings.listMappingVersions(id),
    enabled: !!id,
  });
}

export function useRevertMapping(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['mappings']['revertMapping']>[0]; request: Parameters<InferrexClient['mappings']['revertMapping']>[1] }) => getClient().mappings.revertMapping(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['mappings'] });
    },
  });
}

export function useApproveConnection(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['connections']['approveConnection']>[0]) => getClient().connections.approveConnection(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useApproveField(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['connections']['approveField']>[0]; request: Parameters<InferrexClient['connections']['approveField']>[1] }) => getClient().connections.approveField(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useSetFieldInclusion(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['connections']['setFieldInclusion']>[0]; request: Parameters<InferrexClient['connections']['setFieldInclusion']>[1] }) => getClient().connections.setFieldInclusion(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useSetConnectionPathParams(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['connections']['setConnectionPathParams']>[0]; request: Parameters<InferrexClient['connections']['setConnectionPathParams']>[1] }) => getClient().connections.setConnectionPathParams(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useSetEntityUpdateVia(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['connections']['setEntityUpdateVia']>[0]; entityId: Parameters<InferrexClient['connections']['setEntityUpdateVia']>[1]; request: Parameters<InferrexClient['connections']['setEntityUpdateVia']>[2] }) => getClient().connections.setEntityUpdateVia(vars.id, vars.entityId, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useSetConnectionWriteEncoding(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['connections']['setConnectionWriteEncoding']>[0]; request: Parameters<InferrexClient['connections']['setConnectionWriteEncoding']>[1] }) => getClient().connections.setConnectionWriteEncoding(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useSetFieldGroups(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['connections']['setFieldGroups']>[0]; request: Parameters<InferrexClient['connections']['setFieldGroups']>[1] }) => getClient().connections.setFieldGroups(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useGetConnectionAudit(id: string) {
  return useQuery({
    queryKey: ['connections', id, 'audit'],
    queryFn: () => getClient().connections.getConnectionAudit(id),
    enabled: !!id,
  });
}

export function useAssessScope(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['connections']['assessScope']>[0]) => getClient().connections.assessScope(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connections'] });
    },
  });
}

export function useStoreCredentials(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['credentials']['storeCredentials']>[0]; request: Parameters<InferrexClient['credentials']['storeCredentials']>[1] }) => getClient().credentials.storeCredentials(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['credentials'] });
    },
  });
}

export function useListCredentials(id: string) {
  return useQuery({
    queryKey: ['connections', id, 'credentials'],
    queryFn: () => getClient().credentials.listCredentials(id),
    enabled: !!id,
  });
}

export function useRevokeCredentials(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['credentials']['revokeCredentials']>[0]; request: Parameters<InferrexClient['credentials']['revokeCredentials']>[1] }) => getClient().credentials.revokeCredentials(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['credentials'] });
    },
  });
}

export function useRotateCredentials(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['credentials']['rotateCredentials']>[0]) => getClient().credentials.rotateCredentials(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['credentials'] });
    },
  });
}

export function useListPipelinePromotions() {
  return useQuery({
    queryKey: ['pipeline-promotions'],
    queryFn: () => getClient().pipelines.listPipelinePromotions(),
  });
}

export function useCreatePipeline(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['pipelines']['createPipeline']>[0]) => getClient().pipelines.createPipeline(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['pipelines'] });
    },
  });
}

export function usePipelines() {
  return useQuery({
    queryKey: ['pipelines'],
    queryFn: () => getClient().pipelines.listPipelines().then((r) => r.pipelines),
  });
}

export function usePipeline(id: string) {
  return useQuery({
    queryKey: ['pipelines', id],
    queryFn: () => getClient().pipelines.getPipeline(id),
    enabled: !!id,
  });
}

export function useActivatePipeline(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['pipelines']['activatePipeline']>[0]) => getClient().pipelines.activatePipeline(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['pipelines'] });
    },
  });
}

export function useSetPipelineSchedule(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['pipelines']['setPipelineSchedule']>[0]; request: Parameters<InferrexClient['pipelines']['setPipelineSchedule']>[1] }) => getClient().pipelines.setPipelineSchedule(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['pipelines'] });
    },
  });
}

export function useArchivePipeline(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['pipelines']['archivePipeline']>[0]) => getClient().pipelines.archivePipeline(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['pipelines'] });
    },
  });
}

export function usePausePipeline(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['pipelines']['pausePipeline']>[0]) => getClient().pipelines.pausePipeline(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['pipelines'] });
    },
  });
}

export function useTriggerSync(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['pipelines']['triggerSync']>[0]; request: Parameters<InferrexClient['pipelines']['triggerSync']>[1] }) => getClient().pipelines.triggerSync(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['pipelines'] });
    },
  });
}

export function useDryRunPipeline(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['pipelines']['dryRunPipeline']>[0]) => getClient().pipelines.dryRunPipeline(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['pipelines'] });
    },
  });
}

export function useStartParallelRun(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['pipelines']['startParallelRun']>[0]; request: Parameters<InferrexClient['pipelines']['startParallelRun']>[1] }) => getClient().pipelines.startParallelRun(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['pipelines'] });
    },
  });
}

export function useSyncHistory(id: string) {
  return useQuery({
    queryKey: ['pipelines', id, 'history'],
    queryFn: () => getClient().pipelines.getSyncHistory(id),
    enabled: !!id,
  });
}

export function useAnomalyDetection(id: string) {
  return useQuery({
    queryKey: ['pipelines', id, 'anomalies'],
    queryFn: () => getClient().pipelines.getAnomalies(id).then((r) => r.anomalies),
    enabled: !!id,
  });
}

export function usePipelineQuarantine(id: string) {
  return useQuery({
    queryKey: ['pipelines', id, 'quarantine'],
    queryFn: () => getClient().pipelines.listPipelineQuarantine(id).then((r) => r.quarantined),
    enabled: !!id,
  });
}

export function useWorkspaceQuarantine(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['quarantine', options ?? {}],
    queryFn: () => getClient().pipelines.listQuarantine(options),
  });
}

export function usePipelineMappings(id: string) {
  return useQuery({
    queryKey: ['pipelines', id, 'mappings'],
    queryFn: () => getClient().pipelines.listPipelineMappings(id).then((r) => r.mappings),
    enabled: !!id,
  });
}

export function useGetJob(id: string) {
  return useQuery({
    queryKey: ['jobs', id],
    queryFn: () => getClient().jobs.getJob(id),
    enabled: !!id,
  });
}

export function useCancelJob(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['jobs']['cancelJob']>[0]) => getClient().jobs.cancelJob(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['jobs'] });
    },
  });
}

export function useSuggestions(id: string) {
  return useQuery({
    queryKey: ['pipelines', id, 'suggestions'],
    queryFn: () => getClient().pipelines.listSuggestions(id).then((r) => r.suggestions),
    enabled: !!id,
  });
}

export function useListEntityValueProfiles() {
  return useQuery({
    queryKey: ['intelligence', 'value-profiles'],
    queryFn: () => getClient().intelligence.listEntityValueProfiles().then((r) => r.profiles),
  });
}

export function useListPartnerOpportunities() {
  return useQuery({
    queryKey: ['intelligence', 'partners'],
    queryFn: () => getClient().intelligence.listPartnerOpportunities(),
  });
}

export function useConnectPartner(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['intelligence']['connectPartner']>[0]) => getClient().intelligence.connectPartner(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['intelligence'] });
    },
  });
}

export function useGetStackMap() {
  return useQuery({
    queryKey: ['intelligence', 'stack-map'],
    queryFn: () => getClient().intelligence.getStackMap(),
  });
}

export function useGetDataModel() {
  return useQuery({
    queryKey: ['intelligence', 'data-model'],
    queryFn: () => getClient().intelligence.getDataModel(),
  });
}

export function useGetConsolidation() {
  return useQuery({
    queryKey: ['intelligence', 'consolidation'],
    queryFn: () => getClient().intelligence.getConsolidation(),
  });
}

export function useGetDarkDataReport() {
  return useQuery({
    queryKey: ['intelligence', 'dark-data-report'],
    queryFn: () => getClient().intelligence.getDarkDataReport(),
  });
}

export function useGetEnrichmentOpportunities(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['intelligence', 'enrichment-opportunities', options ?? {}],
    queryFn: () => getClient().intelligence.getEnrichmentOpportunities(options),
  });
}

export function useGetStackBloatReport() {
  return useQuery({
    queryKey: ['intelligence', 'stack-bloat-report'],
    queryFn: () => getClient().intelligence.getStackBloatReport(),
  });
}

export function useListStackInsights(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['intelligence', 'insights', options ?? {}],
    queryFn: () => getClient().intelligence.listStackInsights(options),
  });
}

export function useAcknowledgeDrift(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['intelligence']['acknowledgeDrift']>[0]) => getClient().intelligence.acknowledgeDrift(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['intelligence'] });
    },
  });
}

export function usePreviewMigration(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['migration']['previewMigration']>[0]) => getClient().migration.previewMigration(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['migration'] });
    },
  });
}

export function useCancelMigration(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['migration']['cancelMigration']>[0]) => getClient().migration.cancelMigration(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['migration'] });
    },
  });
}

export function useExecuteMigration(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['migration']['executeMigration']>[0]) => getClient().migration.executeMigration(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['migration'] });
    },
  });
}

export function useListGamificationState(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['gamification', 'state', options ?? {}],
    queryFn: () => getClient().gamification.listGamificationState(options).then((r) => r.state),
  });
}

export function useActivateArchival(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['archival']['activateArchival']>[0]) => getClient().archival.activateArchival(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['archival'] });
    },
  });
}

export function useArchivalDashboard() {
  return useQuery({
    queryKey: ['archival', 'dashboard'],
    queryFn: () => getClient().archival.getArchivalDashboard(),
  });
}

export function useListArchivedRecords(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['archival', 'records', options ?? {}],
    queryFn: () => getClient().archival.listArchivedRecords(options).then((r) => r.records),
  });
}

export function useRestoreRecords(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['archival']['restoreRecords']>[0]) => getClient().archival.restoreRecords(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['archival'] });
    },
  });
}

export function useGetArchivedRecord(recordId: string) {
  return useQuery({
    queryKey: ['retrieve', recordId],
    queryFn: () => getClient().retrieval.getArchivedRecord(recordId),
    enabled: !!recordId,
  });
}

export function useGetArchivedRecordStatus(recordId: string) {
  return useQuery({
    queryKey: ['retrieve', recordId, 'status'],
    queryFn: () => getClient().retrieval.getArchivedRecordStatus(recordId),
    enabled: !!recordId,
  });
}

export function useSearchConnectors(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['library', 'connectors', options ?? {}],
    queryFn: () => getClient().library.searchConnectors(options),
  });
}

export function useGetConnectorManifest(providerKey: string) {
  return useQuery({
    queryKey: ['library', 'connectors', providerKey],
    queryFn: () => getClient().library.getConnectorManifest(providerKey),
    enabled: !!providerKey,
  });
}

export function useListCategories() {
  return useQuery({
    queryKey: ['library', 'categories'],
    queryFn: () => getClient().library.listCategories(),
  });
}

export function useSubmitConnectorContribution(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['library']['submitConnectorContribution']>[0]) => getClient().library.submitConnectorContribution(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['library'] });
    },
  });
}

export function useGetContributionStatus(id: string) {
  return useQuery({
    queryKey: ['library', 'contributions', id],
    queryFn: () => getClient().library.getContributionStatus(id),
    enabled: !!id,
  });
}

export function useUpload(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['library']['upload']>[0]) => getClient().library.upload(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['library'] });
    },
  });
}

export function useSearch(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['search', options ?? {}],
    queryFn: () => getClient().search.search(options),
  });
}

export function useListNotifications(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['notifications', options ?? {}],
    queryFn: () => getClient().notifications.listNotifications(options),
  });
}

export function useGetUnreadNotificationCount() {
  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: () => getClient().notifications.getUnreadNotificationCount(),
  });
}

export function useMarkNotificationRead(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['notifications']['markNotificationRead']>[0]) => getClient().notifications.markNotificationRead(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export function useMarkAllNotificationsRead(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => getClient().notifications.markAllNotificationsRead({ idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export function useHealLog(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['healing', options ?? {}],
    queryFn: () => getClient().heals.listHeals(options),
  });
}

export function useAnswerHeal(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['heals']['answerHeal']>[0]; request: Parameters<InferrexClient['heals']['answerHeal']>[1] }) => getClient().heals.answerHeal(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['healing'] });
    },
  });
}

export function useGoldenRecords(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['unified', 'records', options ?? {}],
    queryFn: () => getClient().unified_api.unifiedListAction(options).then((r) => r.records),
  });
}

export function useGoldenRecord(entityClusterId: string) {
  return useQuery({
    queryKey: ['unified', 'records', entityClusterId],
    queryFn: () => getClient().unified_api.unifiedGetAction(entityClusterId),
    enabled: !!entityClusterId,
  });
}

export function useGoldenRecordFields(entityClusterId: string) {
  return useQuery({
    queryKey: ['golden-records', entityClusterId, 'fields'],
    queryFn: () => getClient().unified_api.getGoldenRecordFields(entityClusterId).then((r) => r.fields),
    enabled: !!entityClusterId,
  });
}

export function useSyncGoldenRecord(requestOptions?: MutationRequestOptions) {
  return useMutation({
    mutationFn: (vars: { entityClusterId: Parameters<InferrexClient['unified_api']['syncGoldenRecord']>[0]; request: Parameters<InferrexClient['unified_api']['syncGoldenRecord']>[1] }) => getClient().unified_api.syncGoldenRecord(vars.entityClusterId, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
  });
}

export function useSyncGoldenRecordsBatch(requestOptions?: MutationRequestOptions) {
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['unified_api']['syncGoldenRecordsBatch']>[0]) => getClient().unified_api.syncGoldenRecordsBatch(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
  });
}

export function useGetPricing() {
  return useQuery({
    queryKey: ['pricing'],
    queryFn: () => getClient().pricing.getPricing(),
  });
}

export function useRotateWebhookSecret(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['event_subscriptions']['rotateWebhookSecret']>[0]) => getClient().event_subscriptions.rotateWebhookSecret(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['event_subscriptions'] });
    },
  });
}

export function useTestWebhookSubscription(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['event_subscriptions']['testWebhookSubscription']>[0]) => getClient().event_subscriptions.testWebhookSubscription(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['event_subscriptions'] });
    },
  });
}

export function useGetBillingStatus() {
  return useQuery({
    queryKey: ['billing', 'status'],
    queryFn: () => getClient().billing.getBillingStatus(),
  });
}

export function useSubmitProfile(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['billing']['submitProfile']>[0]) => getClient().billing.submitProfile(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['billing'] });
    },
  });
}

export function useCreateCheckout(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['billing']['createCheckout']>[0]) => getClient().billing.createCheckout(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['billing'] });
    },
  });
}

export function useRequestUpgrade(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['billing']['requestUpgrade']>[0]) => getClient().billing.requestUpgrade(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['billing'] });
    },
  });
}

export function usePurchasePack(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['billing']['purchasePack']>[0]) => getClient().billing.purchasePack(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['billing'] });
    },
  });
}

export function useImportStripeCatalog(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => getClient().billing.importStripeCatalog({ idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['billing'] });
    },
  });
}

export function useSyncStripeCatalog(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => getClient().billing.syncStripeCatalog({ idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['billing'] });
    },
  });
}

export function useRollbackChange(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['billing']['rollbackChange']>[0]) => getClient().billing.rollbackChange(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['billing'] });
    },
  });
}

export function useAdminGetTenantCliMemory(id: string) {
  return useQuery({
    queryKey: ['admin', 'tenants', id, 'cli-memory'],
    queryFn: () => getClient().admin.adminGetTenantCliMemory(id),
    enabled: !!id,
  });
}

export function useAdminClearTenantCliMemory(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminClearTenantCliMemory']>[0]) => getClient().admin.adminClearTenantCliMemory(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminTenantSuspend(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminTenantSuspend']>[0]; request: Parameters<InferrexClient['admin']['adminTenantSuspend']>[1] }) => getClient().admin.adminTenantSuspend(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminTenantReactivate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminTenantReactivate']>[0]) => getClient().admin.adminTenantReactivate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminTenantDecommission(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminTenantDecommission']>[0]; request: Parameters<InferrexClient['admin']['adminTenantDecommission']>[1] }) => getClient().admin.adminTenantDecommission(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useListPromotionCandidates(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'connector-library', 'candidates', options ?? {}],
    queryFn: () => getClient().governance.listPromotionCandidates(options),
  });
}

export function useGetTenantSensitivityMap(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['governance', 'sensitivity-map', options ?? {}],
    queryFn: () => getClient().governance.getTenantSensitivityMap(options),
  });
}

export function useGetProviderChanges(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['governance', 'provider-changes', options ?? {}],
    queryFn: () => getClient().governance.getProviderChanges(options),
  });
}

export function useGetSensitivityMap(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'sensitivity-map', options ?? {}],
    queryFn: () => getClient().governance.getSensitivityMap(options),
  });
}

export function useGetAdminOpsSummary() {
  return useQuery({
    queryKey: ['admin', 'ops-summary'],
    queryFn: () => getClient().admin.getAdminOpsSummary(),
  });
}

export function useGetAdminEngineSummary() {
  return useQuery({
    queryKey: ['admin', 'engine-summary'],
    queryFn: () => getClient().admin.getAdminEngineSummary(),
  });
}

export function useGetAdminAiAnswersSummary() {
  return useQuery({
    queryKey: ['admin', 'ai-answers', 'summary'],
    queryFn: () => getClient().admin.getAdminAiAnswersSummary(),
  });
}

export function useListAdminAiAnswers(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'ai-answers', options ?? {}],
    queryFn: () => getClient().admin.listAdminAiAnswers(options),
  });
}

export function useFlagPromotionCandidate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['governance']['flagPromotionCandidate']>[0]) => getClient().governance.flagPromotionCandidate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['governance'] });
    },
  });
}

export function useRejectPromotionCandidate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['governance']['rejectPromotionCandidate']>[0]) => getClient().governance.rejectPromotionCandidate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['governance'] });
    },
  });
}

export function usePromoteConnector(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['governance']['promoteConnector']>[0]; request: Parameters<InferrexClient['governance']['promoteConnector']>[1] }) => getClient().governance.promoteConnector(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['governance'] });
    },
  });
}

export function useListStaging(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'connector-library', 'staging', options ?? {}],
    queryFn: () => getClient().governance.listStaging(options),
  });
}

export function useRejectStagedContribution(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['governance']['rejectStagedContribution']>[0]; request: Parameters<InferrexClient['governance']['rejectStagedContribution']>[1] }) => getClient().governance.rejectStagedContribution(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['governance'] });
    },
  });
}

export function useCutRelease(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['governance']['cutRelease']>[0]) => getClient().governance.cutRelease(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['governance'] });
    },
  });
}

export function useSetPartnerStatus(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { providerKey: Parameters<InferrexClient['governance']['setPartnerStatus']>[0]; request: Parameters<InferrexClient['governance']['setPartnerStatus']>[1] }) => getClient().governance.setPartnerStatus(vars.providerKey, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['governance'] });
    },
  });
}

export function useDeprecateProviderVersion(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { providerKey: Parameters<InferrexClient['governance']['deprecateProviderVersion']>[0]; version: Parameters<InferrexClient['governance']['deprecateProviderVersion']>[1] }) => getClient().governance.deprecateProviderVersion(vars.providerKey, vars.version, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['governance'] });
    },
  });
}

export function useRefreshLibraryFromSpec(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { providerKey: Parameters<InferrexClient['connector_library']['refreshLibraryFromSpec']>[0]; request: Parameters<InferrexClient['connector_library']['refreshLibraryFromSpec']>[1] }) => getClient().connector_library.refreshLibraryFromSpec(vars.providerKey, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['connector_library'] });
    },
  });
}

export function useAdminToggleCustomerFeature(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { customerId: Parameters<InferrexClient['admin']['adminToggleCustomerFeature']>[0]; request: Parameters<InferrexClient['admin']['adminToggleCustomerFeature']>[1] }) => getClient().admin.adminToggleCustomerFeature(vars.customerId, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminEmailSend(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminEmailSend']>[0]) => getClient().admin.adminEmailSend(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAcknowledgeAlert(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['monitoring']['acknowledgeAlert']>[0]) => getClient().monitoring.acknowledgeAlert(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useTestAlert(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['monitoring']['testAlert']>[0]) => getClient().monitoring.testAlert(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useGetConnectionHealth() {
  return useQuery({
    queryKey: ['monitoring', 'health'],
    queryFn: () => getClient().monitoring.getConnectionHealth(),
  });
}

export function useGetMonitoringSummary() {
  return useQuery({
    queryKey: ['monitoring', 'summary'],
    queryFn: () => getClient().monitoring.getMonitoringSummary(),
  });
}

export function useTriggerWorkflow(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['workflows']['triggerWorkflow']>[0]; request: Parameters<InferrexClient['workflows']['triggerWorkflow']>[1] }) => getClient().workflows.triggerWorkflow(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workflows'] });
    },
  });
}

export function useCancelRun(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workflows']['cancelRun']>[0]) => getClient().workflows.cancelRun(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workflows'] });
    },
  });
}

export function useEnableWorkflow(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workflows']['enableWorkflow']>[0]) => getClient().workflows.enableWorkflow(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workflows'] });
    },
  });
}

export function useDisableWorkflow(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workflows']['disableWorkflow']>[0]) => getClient().workflows.disableWorkflow(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workflows'] });
    },
  });
}

export function useApproveInitialLoad(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['operations']['approveInitialLoad']>[0]) => getClient().operations.approveInitialLoad(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['operations'] });
    },
  });
}

export function usePauseInitialLoad(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['operations']['pauseInitialLoad']>[0]) => getClient().operations.pauseInitialLoad(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['operations'] });
    },
  });
}

export function useCancelInitialLoad(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['operations']['cancelInitialLoad']>[0]) => getClient().operations.cancelInitialLoad(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['operations'] });
    },
  });
}

export function useApproveQuarantined(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['monitoring']['approveQuarantined']>[0]; request: Parameters<InferrexClient['monitoring']['approveQuarantined']>[1] }) => getClient().monitoring.approveQuarantined(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useRejectQuarantined(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['monitoring']['rejectQuarantined']>[0]; request: Parameters<InferrexClient['monitoring']['rejectQuarantined']>[1] }) => getClient().monitoring.rejectQuarantined(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function usePartialApprove(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['monitoring']['partialApprove']>[0]; request: Parameters<InferrexClient['monitoring']['partialApprove']>[1] }) => getClient().monitoring.partialApprove(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useForceClose(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['monitoring']['forceClose']>[0]; request: Parameters<InferrexClient['monitoring']['forceClose']>[1] }) => getClient().monitoring.forceClose(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useHoldOpen(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['monitoring']['holdOpen']>[0]; request: Parameters<InferrexClient['monitoring']['holdOpen']>[1] }) => getClient().monitoring.holdOpen(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useCircuitBreakerRecords(id: string, options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['circuit-breakers', id, 'records', options ?? {}],
    queryFn: () => getClient().monitoring.listCircuitBreakerRecords(id, options),
    enabled: !!id,
  });
}

export function useRestorationRequestsPreview(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['data_protection']['restorationRequestsPreview']>[0]; request: Parameters<InferrexClient['data_protection']['restorationRequestsPreview']>[1] }) => getClient().data_protection.restorationRequestsPreview(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useRestorationRequestsRequestApproval(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['data_protection']['restorationRequestsRequestApproval']>[0]; request: Parameters<InferrexClient['data_protection']['restorationRequestsRequestApproval']>[1] }) => getClient().data_protection.restorationRequestsRequestApproval(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useRestorationRequestsApprove(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['data_protection']['restorationRequestsApprove']>[0]; request: Parameters<InferrexClient['data_protection']['restorationRequestsApprove']>[1] }) => getClient().data_protection.restorationRequestsApprove(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useRestorationRequestsReject(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['data_protection']['restorationRequestsReject']>[0]; request: Parameters<InferrexClient['data_protection']['restorationRequestsReject']>[1] }) => getClient().data_protection.restorationRequestsReject(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useRestorationRequestsExecute(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['data_protection']['restorationRequestsExecute']>[0]; request: Parameters<InferrexClient['data_protection']['restorationRequestsExecute']>[1] }) => getClient().data_protection.restorationRequestsExecute(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useRestorationRequestsVerify(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['data_protection']['restorationRequestsVerify']>[0]; request: Parameters<InferrexClient['data_protection']['restorationRequestsVerify']>[1] }) => getClient().data_protection.restorationRequestsVerify(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useRestorationRequestsCancel(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['data_protection']['restorationRequestsCancel']>[0]; request: Parameters<InferrexClient['data_protection']['restorationRequestsCancel']>[1] }) => getClient().data_protection.restorationRequestsCancel(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useTriggerScoring(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => getClient().golden_record.triggerScoring({ idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['golden_record'] });
    },
  });
}

export function useAcceptInvite(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['acceptInvite']>[0]) => getClient().workspace.acceptInvite(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useTransferOwnership(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['transferOwnership']>[0]) => getClient().workspace.transferOwnership(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useGetEffectivePermissions(userId: string) {
  return useQuery({
    queryKey: ['workspace', 'effective-permissions', userId],
    queryFn: () => getClient().workspace.getEffectivePermissions(userId),
    enabled: !!userId,
  });
}

export function useApproveProposal(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['golden_record']['approveProposal']>[0]; request: Parameters<InferrexClient['golden_record']['approveProposal']>[1] }) => getClient().golden_record.approveProposal(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['golden_record'] });
    },
  });
}

export function useRejectProposal(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['golden_record']['rejectProposal']>[0]; request: Parameters<InferrexClient['golden_record']['rejectProposal']>[1] }) => getClient().golden_record.rejectProposal(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['golden_record'] });
    },
  });
}

export function useBulkApprove(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['golden_record']['bulkApprove']>[0]) => getClient().golden_record.bulkApprove(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['golden_record'] });
    },
  });
}

export function useSetChannelCredential(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['notifications']['setChannelCredential']>[0]; request: Parameters<InferrexClient['notifications']['setChannelCredential']>[1] }) => getClient().notifications.setChannelCredential(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export function useVerifyChannel(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['notifications']['verifyChannel']>[0]) => getClient().notifications.verifyChannel(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export function useGetEntitySchema(entity: string) {
  return useQuery({
    queryKey: ['schema', entity],
    queryFn: () => getClient().schema.getEntitySchema(entity),
    enabled: !!entity,
  });
}

export function useListPortalReleases() {
  return useQuery({
    queryKey: ['portal', 'releases'],
    queryFn: () => getClient().portal.listPortalReleases(),
  });
}

export function useRequestPortalDownload(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['portal']['requestPortalDownload']>[0]) => getClient().portal.requestPortalDownload(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['portal'] });
    },
  });
}

export function useListPortalLicences() {
  return useQuery({
    queryKey: ['portal', 'licences'],
    queryFn: () => getClient().portal.listPortalLicences(),
  });
}

export function useRevealActivationKey(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['portal']['revealActivationKey']>[0]) => getClient().portal.revealActivationKey(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['portal'] });
    },
  });
}

export function useCreateAssistantConversation(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['assistant']['createAssistantConversation']>[0]) => getClient().assistant.createAssistantConversation(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['assistant'] });
    },
  });
}

export function useListAssistantConversations(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['assistant', 'conversations', options ?? {}],
    queryFn: () => getClient().assistant.listAssistantConversations(options),
  });
}

export function useGetAssistantConversation(id: string) {
  return useQuery({
    queryKey: ['assistant', 'conversations', id],
    queryFn: () => getClient().assistant.getAssistantConversation(id),
    enabled: !!id,
  });
}

export function useUpdateAssistantConversation(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['assistant']['updateAssistantConversation']>[0]; request: Parameters<InferrexClient['assistant']['updateAssistantConversation']>[1] }) => getClient().assistant.updateAssistantConversation(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['assistant'] });
    },
  });
}

export function useSubmitAssistantFeedback(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['assistant']['submitAssistantFeedback']>[0]; request: Parameters<InferrexClient['assistant']['submitAssistantFeedback']>[1] }) => getClient().assistant.submitAssistantFeedback(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['assistant'] });
    },
  });
}

export function useCreateAssistantMemory(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['assistant']['createAssistantMemory']>[0]) => getClient().assistant.createAssistantMemory(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['assistant'] });
    },
  });
}

export function useListAssistantMemories(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['assistant', 'memories', options ?? {}],
    queryFn: () => getClient().assistant.listAssistantMemories(options),
  });
}

export function useUpdateAssistantMemory(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['assistant']['updateAssistantMemory']>[0]; request: Parameters<InferrexClient['assistant']['updateAssistantMemory']>[1] }) => getClient().assistant.updateAssistantMemory(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['assistant'] });
    },
  });
}

export function useDeleteAssistantMemory(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['assistant']['deleteAssistantMemory']>[0]) => getClient().assistant.deleteAssistantMemory(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['assistant'] });
    },
  });
}

export function useAdminEnvironmentProfilesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'environment-profiles', options ?? {}],
    queryFn: () => getClient().admin.adminEnvironmentProfilesList(options).then((r) => r.environment_profiles),
  });
}

export function useAdminEnvironmentProfilesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'environment-profiles', id],
    queryFn: () => getClient().admin.adminEnvironmentProfilesGet(id),
    enabled: !!id,
  });
}

export function useAdminEnvironmentProfilesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminEnvironmentProfilesCreate']>[0]) => getClient().admin.adminEnvironmentProfilesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminEnvironmentProfilesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminEnvironmentProfilesUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminEnvironmentProfilesUpdate']>[1] }) => getClient().admin.adminEnvironmentProfilesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminEnvironmentProfilesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminEnvironmentProfilesDelete']>[0]) => getClient().admin.adminEnvironmentProfilesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminReconcileTolerationsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'reconcile-tolerations', options ?? {}],
    queryFn: () => getClient().admin.adminReconcileTolerationsList(options).then((r) => r.reconcile_tolerations),
  });
}

export function useAdminReconcileTolerationsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'reconcile-tolerations', id],
    queryFn: () => getClient().admin.adminReconcileTolerationsGet(id),
    enabled: !!id,
  });
}

export function useAdminReconcileTolerationsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminReconcileTolerationsCreate']>[0]) => getClient().admin.adminReconcileTolerationsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminReconcileTolerationsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminReconcileTolerationsUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminReconcileTolerationsUpdate']>[1] }) => getClient().admin.adminReconcileTolerationsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminReconcileTolerationsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminReconcileTolerationsDelete']>[0]) => getClient().admin.adminReconcileTolerationsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminCorpusSourcesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'corpus-sources', options ?? {}],
    queryFn: () => getClient().admin.adminCorpusSourcesList(options).then((r) => r.corpus_sources),
  });
}

export function useAdminCorpusSourcesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'corpus-sources', id],
    queryFn: () => getClient().admin.adminCorpusSourcesGet(id),
    enabled: !!id,
  });
}

export function useAdminCorpusSourcesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminCorpusSourcesCreate']>[0]) => getClient().admin.adminCorpusSourcesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminCorpusSourcesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminCorpusSourcesUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminCorpusSourcesUpdate']>[1] }) => getClient().admin.adminCorpusSourcesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminCorpusSourcesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminCorpusSourcesDelete']>[0]) => getClient().admin.adminCorpusSourcesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminScraperJobsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'scraper-jobs', options ?? {}],
    queryFn: () => getClient().admin.adminScraperJobsList(options).then((r) => r.scraper_jobs),
  });
}

export function useAdminScraperJobsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'scraper-jobs', id],
    queryFn: () => getClient().admin.adminScraperJobsGet(id),
    enabled: !!id,
  });
}

export function useAdminTrainingJobsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'training-jobs', options ?? {}],
    queryFn: () => getClient().admin.adminTrainingJobsList(options).then((r) => r.training_jobs),
  });
}

export function useAdminTrainingJobsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'training-jobs', id],
    queryFn: () => getClient().admin.adminTrainingJobsGet(id),
    enabled: !!id,
  });
}

export function useAdminTenantsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'tenants', options ?? {}],
    queryFn: () => getClient().admin.adminTenantsList(options).then((r) => r.tenants),
  });
}

export function useAdminTenantsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'tenants', id],
    queryFn: () => getClient().admin.adminTenantsGet(id),
    enabled: !!id,
  });
}

export function useAdminTenantsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminTenantsUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminTenantsUpdate']>[1] }) => getClient().admin.adminTenantsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminContactSubmissionsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'leads', options ?? {}],
    queryFn: () => getClient().admin.adminContactSubmissionsList(options).then((r) => r.contact_submissions),
  });
}

export function useAdminContactSubmissionsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'leads', id],
    queryFn: () => getClient().admin.adminContactSubmissionsGet(id),
    enabled: !!id,
  });
}

export function useAdminContactSubmissionsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminContactSubmissionsUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminContactSubmissionsUpdate']>[1] }) => getClient().admin.adminContactSubmissionsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminDealsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'deals', options ?? {}],
    queryFn: () => getClient().admin.adminDealsList(options).then((r) => r.deals),
  });
}

export function useAdminDealsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'deals', id],
    queryFn: () => getClient().admin.adminDealsGet(id),
    enabled: !!id,
  });
}

export function useAdminDealsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminDealsCreate']>[0]) => getClient().admin.adminDealsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminDealsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminDealsUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminDealsUpdate']>[1] }) => getClient().admin.adminDealsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminActivitiesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'activities', options ?? {}],
    queryFn: () => getClient().admin.adminActivitiesList(options).then((r) => r.activities),
  });
}

export function useAdminActivitiesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'activities', id],
    queryFn: () => getClient().admin.adminActivitiesGet(id),
    enabled: !!id,
  });
}

export function useAdminActivitiesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminActivitiesCreate']>[0]) => getClient().admin.adminActivitiesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminUsersList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'users', options ?? {}],
    queryFn: () => getClient().admin.adminUsersList(options).then((r) => r.users),
  });
}

export function useAdminUsersGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'users', id],
    queryFn: () => getClient().admin.adminUsersGet(id),
    enabled: !!id,
  });
}

export function useAdminCompaniesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'companies', options ?? {}],
    queryFn: () => getClient().admin.adminCompaniesList(options).then((r) => r.companies),
  });
}

export function useAdminCompaniesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'companies', id],
    queryFn: () => getClient().admin.adminCompaniesGet(id),
    enabled: !!id,
  });
}

export function useAdminCompaniesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminCompaniesCreate']>[0]) => getClient().admin.adminCompaniesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminCompaniesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminCompaniesUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminCompaniesUpdate']>[1] }) => getClient().admin.adminCompaniesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminCompaniesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminCompaniesDelete']>[0]) => getClient().admin.adminCompaniesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminContactsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'contacts', options ?? {}],
    queryFn: () => getClient().admin.adminContactsList(options).then((r) => r.contacts),
  });
}

export function useAdminContactsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'contacts', id],
    queryFn: () => getClient().admin.adminContactsGet(id),
    enabled: !!id,
  });
}

export function useAdminContactsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminContactsCreate']>[0]) => getClient().admin.adminContactsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminContactsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminContactsUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminContactsUpdate']>[1] }) => getClient().admin.adminContactsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminContactsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminContactsDelete']>[0]) => getClient().admin.adminContactsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminLicencesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'licences', options ?? {}],
    queryFn: () => getClient().admin.adminLicencesList(options).then((r) => r.licences),
  });
}

export function useAdminLicencesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'licences', id],
    queryFn: () => getClient().admin.adminLicencesGet(id),
    enabled: !!id,
  });
}

export function useAdminLicencesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminLicencesUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminLicencesUpdate']>[1] }) => getClient().admin.adminLicencesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminAuditLogList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'admin-audit', options ?? {}],
    queryFn: () => getClient().admin.adminAuditLogList(options).then((r) => r.audit_log),
  });
}

export function useAdminAuditLogGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'admin-audit', id],
    queryFn: () => getClient().admin.adminAuditLogGet(id),
    enabled: !!id,
  });
}

export function useAdminBillingProductsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'billing-products', options ?? {}],
    queryFn: () => getClient().admin.adminBillingProductsList(options).then((r) => r.billing_products),
  });
}

export function useAdminBillingProductsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'billing-products', id],
    queryFn: () => getClient().admin.adminBillingProductsGet(id),
    enabled: !!id,
  });
}

export function useAdminBillingProductsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminBillingProductsCreate']>[0]) => getClient().admin.adminBillingProductsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingProductsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminBillingProductsUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminBillingProductsUpdate']>[1] }) => getClient().admin.adminBillingProductsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingProductsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminBillingProductsDelete']>[0]) => getClient().admin.adminBillingProductsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingPricesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'billing-prices', options ?? {}],
    queryFn: () => getClient().admin.adminBillingPricesList(options).then((r) => r.billing_prices),
  });
}

export function useAdminBillingPricesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'billing-prices', id],
    queryFn: () => getClient().admin.adminBillingPricesGet(id),
    enabled: !!id,
  });
}

export function useAdminBillingPricesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminBillingPricesCreate']>[0]) => getClient().admin.adminBillingPricesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingPricesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminBillingPricesUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminBillingPricesUpdate']>[1] }) => getClient().admin.adminBillingPricesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingPricesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminBillingPricesDelete']>[0]) => getClient().admin.adminBillingPricesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingProductFeaturesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'billing-product-features', options ?? {}],
    queryFn: () => getClient().admin.adminBillingProductFeaturesList(options).then((r) => r.billing_product_features),
  });
}

export function useAdminBillingProductFeaturesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'billing-product-features', id],
    queryFn: () => getClient().admin.adminBillingProductFeaturesGet(id),
    enabled: !!id,
  });
}

export function useAdminBillingProductFeaturesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminBillingProductFeaturesCreate']>[0]) => getClient().admin.adminBillingProductFeaturesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingProductFeaturesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminBillingProductFeaturesDelete']>[0]) => getClient().admin.adminBillingProductFeaturesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingFeaturesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'billing-features', options ?? {}],
    queryFn: () => getClient().admin.adminBillingFeaturesList(options).then((r) => r.billing_features),
  });
}

export function useAdminBillingFeaturesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'billing-features', id],
    queryFn: () => getClient().admin.adminBillingFeaturesGet(id),
    enabled: !!id,
  });
}

export function useAdminBillingFeaturesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminBillingFeaturesCreate']>[0]) => getClient().admin.adminBillingFeaturesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingFeaturesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminBillingFeaturesUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminBillingFeaturesUpdate']>[1] }) => getClient().admin.adminBillingFeaturesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingFeaturesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminBillingFeaturesDelete']>[0]) => getClient().admin.adminBillingFeaturesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingOffersList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'billing-offers', options ?? {}],
    queryFn: () => getClient().admin.adminBillingOffersList(options).then((r) => r.billing_offers),
  });
}

export function useAdminBillingOffersGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'billing-offers', id],
    queryFn: () => getClient().admin.adminBillingOffersGet(id),
    enabled: !!id,
  });
}

export function useAdminBillingOffersCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminBillingOffersCreate']>[0]) => getClient().admin.adminBillingOffersCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingOffersUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminBillingOffersUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminBillingOffersUpdate']>[1] }) => getClient().admin.adminBillingOffersUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingOffersDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminBillingOffersDelete']>[0]) => getClient().admin.adminBillingOffersDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminBillingChangelogList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'billing-changelog', options ?? {}],
    queryFn: () => getClient().admin.adminBillingChangelogList(options).then((r) => r.billing_changelog),
  });
}

export function useAdminBillingChangelogGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'billing-changelog', id],
    queryFn: () => getClient().admin.adminBillingChangelogGet(id),
    enabled: !!id,
  });
}

export function useAdminPlatformAuditTrailList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'audit', options ?? {}],
    queryFn: () => getClient().admin.adminPlatformAuditTrailList(options).then((r) => r.platform_audit_trail),
  });
}

export function useAdminPlatformAuditTrailGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'audit', id],
    queryFn: () => getClient().admin.adminPlatformAuditTrailGet(id),
    enabled: !!id,
  });
}

export function useWorkspaceUsersList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workspace', 'users', options ?? {}],
    queryFn: () => getClient().rbac.workspaceUsersList(options).then((r) => r.workspace_users),
  });
}

export function useWorkspaceUsersGet(id: string) {
  return useQuery({
    queryKey: ['workspace', 'users', id],
    queryFn: () => getClient().rbac.workspaceUsersGet(id),
    enabled: !!id,
  });
}

export function useWorkspaceUsersCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['rbac']['workspaceUsersCreate']>[0]) => getClient().rbac.workspaceUsersCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['rbac'] });
    },
  });
}

export function useWorkspaceUsersUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['rbac']['workspaceUsersUpdate']>[0]; request: Parameters<InferrexClient['rbac']['workspaceUsersUpdate']>[1] }) => getClient().rbac.workspaceUsersUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['rbac'] });
    },
  });
}

export function useWorkspaceUsersDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['rbac']['workspaceUsersDelete']>[0]) => getClient().rbac.workspaceUsersDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['rbac'] });
    },
  });
}

export function useTeamsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workspace', 'teams', options ?? {}],
    queryFn: () => getClient().rbac.teamsList(options).then((r) => r.teams),
  });
}

export function useTeamsGet(id: string) {
  return useQuery({
    queryKey: ['workspace', 'teams', id],
    queryFn: () => getClient().rbac.teamsGet(id),
    enabled: !!id,
  });
}

export function useTeamsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['rbac']['teamsCreate']>[0]) => getClient().rbac.teamsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['rbac'] });
    },
  });
}

export function useTeamsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['rbac']['teamsUpdate']>[0]; request: Parameters<InferrexClient['rbac']['teamsUpdate']>[1] }) => getClient().rbac.teamsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['rbac'] });
    },
  });
}

export function useTeamsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['rbac']['teamsDelete']>[0]) => getClient().rbac.teamsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['rbac'] });
    },
  });
}

export function useTeamMembersList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workspace', 'team-members', options ?? {}],
    queryFn: () => getClient().rbac.teamMembersList(options).then((r) => r.team_members),
  });
}

export function useTeamMembersCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['rbac']['teamMembersCreate']>[0]) => getClient().rbac.teamMembersCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['rbac'] });
    },
  });
}

export function useTeamResourcesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workspace', 'team-resources', options ?? {}],
    queryFn: () => getClient().rbac.teamResourcesList(options).then((r) => r.team_resources),
  });
}

export function useTeamResourcesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['rbac']['teamResourcesCreate']>[0]) => getClient().rbac.teamResourcesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['rbac'] });
    },
  });
}

export function useResourcePermissionsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workspace', 'permissions', options ?? {}],
    queryFn: () => getClient().rbac.resourcePermissionsList(options).then((r) => r.resource_permissions),
  });
}

export function useResourcePermissionsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['rbac']['resourcePermissionsCreate']>[0]) => getClient().rbac.resourcePermissionsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['rbac'] });
    },
  });
}

export function useResourcePermissionsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['rbac']['resourcePermissionsDelete']>[0]) => getClient().rbac.resourcePermissionsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['rbac'] });
    },
  });
}

export function usePlatformAuditTrailList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workspace', 'audit-trail', options ?? {}],
    queryFn: () => getClient().rbac.platformAuditTrailList(options).then((r) => r.platform_audit_trail),
  });
}

export function useEnvironmentsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workspace', 'environments', options ?? {}],
    queryFn: () => getClient().workspace.environmentsList(options).then((r) => r.environments),
  });
}

export function useEnvironmentsGet(id: string) {
  return useQuery({
    queryKey: ['workspace', 'environments', id],
    queryFn: () => getClient().workspace.environmentsGet(id),
    enabled: !!id,
  });
}

export function useEnvironmentsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['environmentsCreate']>[0]) => getClient().workspace.environmentsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useEnvironmentsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['workspace']['environmentsUpdate']>[0]; request: Parameters<InferrexClient['workspace']['environmentsUpdate']>[1] }) => getClient().workspace.environmentsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useEnvironmentsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['environmentsDelete']>[0]) => getClient().workspace.environmentsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function usePromotionEdgesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workspace', 'promotion-edges', options ?? {}],
    queryFn: () => getClient().workspace.promotionEdgesList(options).then((r) => r.promotion_edges),
  });
}

export function usePromotionEdgesGet(id: string) {
  return useQuery({
    queryKey: ['workspace', 'promotion-edges', id],
    queryFn: () => getClient().workspace.promotionEdgesGet(id),
    enabled: !!id,
  });
}

export function usePromotionEdgesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['promotionEdgesCreate']>[0]) => getClient().workspace.promotionEdgesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function usePromotionEdgesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['workspace']['promotionEdgesUpdate']>[0]; request: Parameters<InferrexClient['workspace']['promotionEdgesUpdate']>[1] }) => getClient().workspace.promotionEdgesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function usePromotionEdgesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['promotionEdgesDelete']>[0]) => getClient().workspace.promotionEdgesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useConnectionEnvironmentBindingsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['connection-environment-bindings', options ?? {}],
    queryFn: () => getClient().workspace.connectionEnvironmentBindingsList(options).then((r) => r.connection_environment_bindings),
  });
}

export function useConnectionEnvironmentBindingsGet(id: string) {
  return useQuery({
    queryKey: ['connection-environment-bindings', id],
    queryFn: () => getClient().workspace.connectionEnvironmentBindingsGet(id),
    enabled: !!id,
  });
}

export function useConnectionEnvironmentBindingsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['connectionEnvironmentBindingsCreate']>[0]) => getClient().workspace.connectionEnvironmentBindingsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useConnectionEnvironmentBindingsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['workspace']['connectionEnvironmentBindingsUpdate']>[0]; request: Parameters<InferrexClient['workspace']['connectionEnvironmentBindingsUpdate']>[1] }) => getClient().workspace.connectionEnvironmentBindingsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useConnectionEnvironmentBindingsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['connectionEnvironmentBindingsDelete']>[0]) => getClient().workspace.connectionEnvironmentBindingsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useInvitePoliciesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workspace', 'invite-policy', options ?? {}],
    queryFn: () => getClient().workspace.invitePoliciesList(options).then((r) => r.invite_policies),
  });
}

export function useInvitePoliciesGet(id: string) {
  return useQuery({
    queryKey: ['workspace', 'invite-policy', id],
    queryFn: () => getClient().workspace.invitePoliciesGet(id),
    enabled: !!id,
  });
}

export function useInvitePoliciesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['invitePoliciesCreate']>[0]) => getClient().workspace.invitePoliciesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useInvitePoliciesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['workspace']['invitePoliciesUpdate']>[0]; request: Parameters<InferrexClient['workspace']['invitePoliciesUpdate']>[1] }) => getClient().workspace.invitePoliciesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useNotificationChannelsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workspace', 'notification-channels', options ?? {}],
    queryFn: () => getClient().workspace.notificationChannelsList(options).then((r) => r.notification_channels),
  });
}

export function useNotificationChannelsGet(id: string) {
  return useQuery({
    queryKey: ['workspace', 'notification-channels', id],
    queryFn: () => getClient().workspace.notificationChannelsGet(id),
    enabled: !!id,
  });
}

export function useNotificationChannelsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['notificationChannelsCreate']>[0]) => getClient().workspace.notificationChannelsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useNotificationChannelsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['workspace']['notificationChannelsUpdate']>[0]; request: Parameters<InferrexClient['workspace']['notificationChannelsUpdate']>[1] }) => getClient().workspace.notificationChannelsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useNotificationChannelsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workspace']['notificationChannelsDelete']>[0]) => getClient().workspace.notificationChannelsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workspace'] });
    },
  });
}

export function useWebhookSubscriptionsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['webhooks', 'subscriptions', options ?? {}],
    queryFn: () => getClient().event_subscriptions.webhookSubscriptionsList(options).then((r) => r.webhook_subscriptions),
  });
}

export function useWebhookSubscriptionsGet(id: string) {
  return useQuery({
    queryKey: ['webhooks', 'subscriptions', id],
    queryFn: () => getClient().event_subscriptions.webhookSubscriptionsGet(id),
    enabled: !!id,
  });
}

export function useWebhookSubscriptionsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['event_subscriptions']['webhookSubscriptionsCreate']>[0]) => getClient().event_subscriptions.webhookSubscriptionsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['event_subscriptions'] });
    },
  });
}

export function useWebhookSubscriptionsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['event_subscriptions']['webhookSubscriptionsUpdate']>[0]; request: Parameters<InferrexClient['event_subscriptions']['webhookSubscriptionsUpdate']>[1] }) => getClient().event_subscriptions.webhookSubscriptionsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['event_subscriptions'] });
    },
  });
}

export function useWebhookSubscriptionsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['event_subscriptions']['webhookSubscriptionsDelete']>[0]) => getClient().event_subscriptions.webhookSubscriptionsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['event_subscriptions'] });
    },
  });
}

export function useRetentionPoliciesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['retention-policies', options ?? {}],
    queryFn: () => getClient().data_protection.retentionPoliciesList(options).then((r) => r.retention_policies),
  });
}

export function useRetentionPoliciesGet(id: string) {
  return useQuery({
    queryKey: ['retention-policies', id],
    queryFn: () => getClient().data_protection.retentionPoliciesGet(id),
    enabled: !!id,
  });
}

export function useRetentionPoliciesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['data_protection']['retentionPoliciesCreate']>[0]) => getClient().data_protection.retentionPoliciesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useRetentionPoliciesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['data_protection']['retentionPoliciesUpdate']>[0]; request: Parameters<InferrexClient['data_protection']['retentionPoliciesUpdate']>[1] }) => getClient().data_protection.retentionPoliciesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useRetentionPoliciesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['data_protection']['retentionPoliciesDelete']>[0]) => getClient().data_protection.retentionPoliciesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useOperationScopesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['operation-scopes', options ?? {}],
    queryFn: () => getClient().core.operationScopesList(options).then((r) => r.operation_scopes),
  });
}

export function useOperationScopesGet(id: string) {
  return useQuery({
    queryKey: ['operation-scopes', id],
    queryFn: () => getClient().core.operationScopesGet(id),
    enabled: !!id,
  });
}

export function useOperationScopesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['operationScopesCreate']>[0]) => getClient().core.operationScopesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useOperationScopesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['core']['operationScopesUpdate']>[0]; request: Parameters<InferrexClient['core']['operationScopesUpdate']>[1] }) => getClient().core.operationScopesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useOperationScopesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['operationScopesDelete']>[0]) => getClient().core.operationScopesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function usePipelineTargetsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['pipeline-targets', options ?? {}],
    queryFn: () => getClient().core.pipelineTargetsList(options).then((r) => r.pipeline_targets),
  });
}

export function usePipelineTargetsGet(id: string) {
  return useQuery({
    queryKey: ['pipeline-targets', id],
    queryFn: () => getClient().core.pipelineTargetsGet(id),
    enabled: !!id,
  });
}

export function usePipelineTargetsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['pipelineTargetsCreate']>[0]) => getClient().core.pipelineTargetsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function usePipelineTargetsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['core']['pipelineTargetsUpdate']>[0]; request: Parameters<InferrexClient['core']['pipelineTargetsUpdate']>[1] }) => getClient().core.pipelineTargetsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function usePipelineTargetsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['pipelineTargetsDelete']>[0]) => getClient().core.pipelineTargetsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useInitialLoadsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['initial-loads', options ?? {}],
    queryFn: () => getClient().operations.initialLoadsList(options).then((r) => r.initial_loads),
  });
}

export function useInitialLoadsGet(id: string) {
  return useQuery({
    queryKey: ['initial-loads', id],
    queryFn: () => getClient().operations.initialLoadsGet(id),
    enabled: !!id,
  });
}

export function useInitialLoadsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['operations']['initialLoadsCreate']>[0]) => getClient().operations.initialLoadsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['operations'] });
    },
  });
}

export function useInitialLoadsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['operations']['initialLoadsUpdate']>[0]; request: Parameters<InferrexClient['operations']['initialLoadsUpdate']>[1] }) => getClient().operations.initialLoadsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['operations'] });
    },
  });
}

export function usePipelineEventsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['pipeline-events', options ?? {}],
    queryFn: () => getClient().monitoring.pipelineEventsList(options).then((r) => r.pipeline_events),
  });
}

export function usePipelineEventsGet(id: string) {
  return useQuery({
    queryKey: ['pipeline-events', id],
    queryFn: () => getClient().monitoring.pipelineEventsGet(id),
    enabled: !!id,
  });
}

export function useAlertDeliveriesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['alert-deliveries', options ?? {}],
    queryFn: () => getClient().monitoring.alertDeliveriesList(options).then((r) => r.alert_deliveries),
  });
}

export function useAlertDeliveriesGet(id: string) {
  return useQuery({
    queryKey: ['alert-deliveries', id],
    queryFn: () => getClient().monitoring.alertDeliveriesGet(id),
    enabled: !!id,
  });
}

export function useAlertRulesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['alert-rules', options ?? {}],
    queryFn: () => getClient().monitoring.alertRulesList(options).then((r) => r.alert_rules),
  });
}

export function useAlertRulesGet(id: string) {
  return useQuery({
    queryKey: ['alert-rules', id],
    queryFn: () => getClient().monitoring.alertRulesGet(id),
    enabled: !!id,
  });
}

export function useAlertRulesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['monitoring']['alertRulesCreate']>[0]) => getClient().monitoring.alertRulesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useAlertRulesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['monitoring']['alertRulesUpdate']>[0]; request: Parameters<InferrexClient['monitoring']['alertRulesUpdate']>[1] }) => getClient().monitoring.alertRulesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useAlertRulesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['monitoring']['alertRulesDelete']>[0]) => getClient().monitoring.alertRulesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useStreamCircuitBreakersList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['circuit-breakers', options ?? {}],
    queryFn: () => getClient().monitoring.streamCircuitBreakersList(options).then((r) => r.stream_circuit_breakers),
  });
}

export function useStreamCircuitBreakersGet(id: string) {
  return useQuery({
    queryKey: ['circuit-breakers', id],
    queryFn: () => getClient().monitoring.streamCircuitBreakersGet(id),
    enabled: !!id,
  });
}

export function useCircuitBreakerPoliciesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['circuit-breaker-policies', options ?? {}],
    queryFn: () => getClient().monitoring.circuitBreakerPoliciesList(options).then((r) => r.circuit_breaker_policies),
  });
}

export function useCircuitBreakerPoliciesGet(id: string) {
  return useQuery({
    queryKey: ['circuit-breaker-policies', id],
    queryFn: () => getClient().monitoring.circuitBreakerPoliciesGet(id),
    enabled: !!id,
  });
}

export function useCircuitBreakerPoliciesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['monitoring']['circuitBreakerPoliciesCreate']>[0]) => getClient().monitoring.circuitBreakerPoliciesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useCircuitBreakerPoliciesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['monitoring']['circuitBreakerPoliciesUpdate']>[0]; request: Parameters<InferrexClient['monitoring']['circuitBreakerPoliciesUpdate']>[1] }) => getClient().monitoring.circuitBreakerPoliciesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useCircuitBreakerPoliciesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['monitoring']['circuitBreakerPoliciesDelete']>[0]) => getClient().monitoring.circuitBreakerPoliciesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['monitoring'] });
    },
  });
}

export function useWorkflowsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workflows', options ?? {}],
    queryFn: () => getClient().workflows.workflowsList(options).then((r) => r.workflows),
  });
}

export function useWorkflowsGet(id: string) {
  return useQuery({
    queryKey: ['workflows', id],
    queryFn: () => getClient().workflows.workflowsGet(id),
    enabled: !!id,
  });
}

export function useWorkflowsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workflows']['workflowsCreate']>[0]) => getClient().workflows.workflowsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workflows'] });
    },
  });
}

export function useWorkflowsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['workflows']['workflowsUpdate']>[0]; request: Parameters<InferrexClient['workflows']['workflowsUpdate']>[1] }) => getClient().workflows.workflowsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workflows'] });
    },
  });
}

export function useWorkflowsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['workflows']['workflowsDelete']>[0]) => getClient().workflows.workflowsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['workflows'] });
    },
  });
}

export function useWorkflowRunsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['workflow-runs', options ?? {}],
    queryFn: () => getClient().workflows.workflowRunsList(options).then((r) => r.workflow_runs),
  });
}

export function useWorkflowRunsGet(id: string) {
  return useQuery({
    queryKey: ['workflow-runs', id],
    queryFn: () => getClient().workflows.workflowRunsGet(id),
    enabled: !!id,
  });
}

export function useFieldAuthorityRulesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['field-authority-rules', options ?? {}],
    queryFn: () => getClient().golden_record.fieldAuthorityRulesList(options).then((r) => r.field_authority_rules),
  });
}

export function useFieldAuthorityRulesGet(id: string) {
  return useQuery({
    queryKey: ['field-authority-rules', id],
    queryFn: () => getClient().golden_record.fieldAuthorityRulesGet(id),
    enabled: !!id,
  });
}

export function useFieldAuthorityRulesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['golden_record']['fieldAuthorityRulesCreate']>[0]) => getClient().golden_record.fieldAuthorityRulesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['golden_record'] });
    },
  });
}

export function useFieldAuthorityRulesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['golden_record']['fieldAuthorityRulesUpdate']>[0]; request: Parameters<InferrexClient['golden_record']['fieldAuthorityRulesUpdate']>[1] }) => getClient().golden_record.fieldAuthorityRulesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['golden_record'] });
    },
  });
}

export function useFieldAuthorityRulesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['golden_record']['fieldAuthorityRulesDelete']>[0]) => getClient().golden_record.fieldAuthorityRulesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['golden_record'] });
    },
  });
}

export function useCanonicalChangeProposalsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['canonical-proposals', options ?? {}],
    queryFn: () => getClient().golden_record.canonicalChangeProposalsList(options).then((r) => r.canonical_change_proposals),
  });
}

export function useCanonicalChangeProposalsGet(id: string) {
  return useQuery({
    queryKey: ['canonical-proposals', id],
    queryFn: () => getClient().golden_record.canonicalChangeProposalsGet(id),
    enabled: !!id,
  });
}

export function useApprovalPoliciesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['approval-policies', options ?? {}],
    queryFn: () => getClient().golden_record.approvalPoliciesList(options).then((r) => r.approval_policies),
  });
}

export function useApprovalPoliciesGet(id: string) {
  return useQuery({
    queryKey: ['approval-policies', id],
    queryFn: () => getClient().golden_record.approvalPoliciesGet(id),
    enabled: !!id,
  });
}

export function useApprovalPoliciesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['golden_record']['approvalPoliciesCreate']>[0]) => getClient().golden_record.approvalPoliciesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['golden_record'] });
    },
  });
}

export function useApprovalPoliciesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['golden_record']['approvalPoliciesUpdate']>[0]; request: Parameters<InferrexClient['golden_record']['approvalPoliciesUpdate']>[1] }) => getClient().golden_record.approvalPoliciesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['golden_record'] });
    },
  });
}

export function useApprovalPoliciesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['golden_record']['approvalPoliciesDelete']>[0]) => getClient().golden_record.approvalPoliciesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['golden_record'] });
    },
  });
}

export function usePlatformValueScoresList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['platform-value-scores', options ?? {}],
    queryFn: () => getClient().golden_record.platformValueScoresList(options).then((r) => r.platform_value_scores),
  });
}

export function usePlatformValueScoresGet(id: string) {
  return useQuery({
    queryKey: ['platform-value-scores', id],
    queryFn: () => getClient().golden_record.platformValueScoresGet(id),
    enabled: !!id,
  });
}

export function useRestorationRequestsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['restoration-requests', options ?? {}],
    queryFn: () => getClient().data_protection.restorationRequestsList(options).then((r) => r.restoration_requests),
  });
}

export function useRestorationRequestsGet(id: string) {
  return useQuery({
    queryKey: ['restoration-requests', id],
    queryFn: () => getClient().data_protection.restorationRequestsGet(id),
    enabled: !!id,
  });
}

export function useRestorationRequestsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['data_protection']['restorationRequestsCreate']>[0]) => getClient().data_protection.restorationRequestsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['data_protection'] });
    },
  });
}

export function useParallelRunDiscrepanciesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['parallel-run-discrepancies', options ?? {}],
    queryFn: () => getClient().data_protection.parallelRunDiscrepanciesList(options).then((r) => r.parallel_run_discrepancies),
  });
}

export function useParallelRunDiscrepanciesGet(id: string) {
  return useQuery({
    queryKey: ['parallel-run-discrepancies', id],
    queryFn: () => getClient().data_protection.parallelRunDiscrepanciesGet(id),
    enabled: !!id,
  });
}

export function useDeletionCertificatesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['archival', 'certificates', options ?? {}],
    queryFn: () => getClient().archival.deletionCertificatesList(options).then((r) => r.deletion_certificates),
  });
}

export function useDeletionCertificatesGet(id: string) {
  return useQuery({
    queryKey: ['archival', 'certificates', id],
    queryFn: () => getClient().archival.deletionCertificatesGet(id),
    enabled: !!id,
  });
}

export function useAdminWorkspaceUsersList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'workspace-users', options ?? {}],
    queryFn: () => getClient().admin.adminWorkspaceUsersList(options).then((r) => r.workspace_users),
  });
}

export function useAdminWorkspaceUsersGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'workspace-users', id],
    queryFn: () => getClient().admin.adminWorkspaceUsersGet(id),
    enabled: !!id,
  });
}

export function useAdminWorkspaceUsersUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminWorkspaceUsersUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminWorkspaceUsersUpdate']>[1] }) => getClient().admin.adminWorkspaceUsersUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteClaimsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'website', 'claims', options ?? {}],
    queryFn: () => getClient().admin.adminWebsiteClaimsList(options).then((r) => r.website_claims),
  });
}

export function useAdminWebsiteClaimsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'website', 'claims', id],
    queryFn: () => getClient().admin.adminWebsiteClaimsGet(id),
    enabled: !!id,
  });
}

export function useAdminWebsiteClaimsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminWebsiteClaimsCreate']>[0]) => getClient().admin.adminWebsiteClaimsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteClaimsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminWebsiteClaimsUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminWebsiteClaimsUpdate']>[1] }) => getClient().admin.adminWebsiteClaimsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteClaimsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminWebsiteClaimsDelete']>[0]) => getClient().admin.adminWebsiteClaimsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteCapabilitiesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'website', 'capabilities', options ?? {}],
    queryFn: () => getClient().admin.adminWebsiteCapabilitiesList(options).then((r) => r.website_capabilities),
  });
}

export function useAdminWebsiteCapabilitiesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'website', 'capabilities', id],
    queryFn: () => getClient().admin.adminWebsiteCapabilitiesGet(id),
    enabled: !!id,
  });
}

export function useAdminWebsiteCapabilitiesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminWebsiteCapabilitiesCreate']>[0]) => getClient().admin.adminWebsiteCapabilitiesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteCapabilitiesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminWebsiteCapabilitiesUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminWebsiteCapabilitiesUpdate']>[1] }) => getClient().admin.adminWebsiteCapabilitiesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteCapabilitiesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminWebsiteCapabilitiesDelete']>[0]) => getClient().admin.adminWebsiteCapabilitiesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsitePartnersList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'website', 'partners', options ?? {}],
    queryFn: () => getClient().admin.adminWebsitePartnersList(options).then((r) => r.website_partners),
  });
}

export function useAdminWebsitePartnersGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'website', 'partners', id],
    queryFn: () => getClient().admin.adminWebsitePartnersGet(id),
    enabled: !!id,
  });
}

export function useAdminWebsitePartnersCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminWebsitePartnersCreate']>[0]) => getClient().admin.adminWebsitePartnersCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsitePartnersUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminWebsitePartnersUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminWebsitePartnersUpdate']>[1] }) => getClient().admin.adminWebsitePartnersUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsitePartnersDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminWebsitePartnersDelete']>[0]) => getClient().admin.adminWebsitePartnersDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteNavigationList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'website', 'navigation', options ?? {}],
    queryFn: () => getClient().admin.adminWebsiteNavigationList(options).then((r) => r.website_navigation),
  });
}

export function useAdminWebsiteNavigationGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'website', 'navigation', id],
    queryFn: () => getClient().admin.adminWebsiteNavigationGet(id),
    enabled: !!id,
  });
}

export function useAdminWebsiteNavigationCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminWebsiteNavigationCreate']>[0]) => getClient().admin.adminWebsiteNavigationCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteNavigationUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminWebsiteNavigationUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminWebsiteNavigationUpdate']>[1] }) => getClient().admin.adminWebsiteNavigationUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteNavigationDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminWebsiteNavigationDelete']>[0]) => getClient().admin.adminWebsiteNavigationDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteCtasList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'website', 'ctas', options ?? {}],
    queryFn: () => getClient().admin.adminWebsiteCtasList(options).then((r) => r.website_ctas),
  });
}

export function useAdminWebsiteCtasGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'website', 'ctas', id],
    queryFn: () => getClient().admin.adminWebsiteCtasGet(id),
    enabled: !!id,
  });
}

export function useAdminWebsiteCtasCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminWebsiteCtasCreate']>[0]) => getClient().admin.adminWebsiteCtasCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteCtasUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminWebsiteCtasUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminWebsiteCtasUpdate']>[1] }) => getClient().admin.adminWebsiteCtasUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminWebsiteCtasDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminWebsiteCtasDelete']>[0]) => getClient().admin.adminWebsiteCtasDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminRuntimeRoutesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'runtime-routes', options ?? {}],
    queryFn: () => getClient().admin.adminRuntimeRoutesList(options).then((r) => r.runtime_routes),
  });
}

export function useAdminRuntimeRoutesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'runtime-routes', id],
    queryFn: () => getClient().admin.adminRuntimeRoutesGet(id),
    enabled: !!id,
  });
}

export function useAdminRuntimeRoutesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminRuntimeRoutesCreate']>[0]) => getClient().admin.adminRuntimeRoutesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminRuntimeRoutesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminRuntimeRoutesUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminRuntimeRoutesUpdate']>[1] }) => getClient().admin.adminRuntimeRoutesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminRuntimeRoutesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminRuntimeRoutesDelete']>[0]) => getClient().admin.adminRuntimeRoutesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminRuntimeTablesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'runtime-tables', options ?? {}],
    queryFn: () => getClient().admin.adminRuntimeTablesList(options).then((r) => r.runtime_tables),
  });
}

export function useAdminRuntimeTablesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'runtime-tables', id],
    queryFn: () => getClient().admin.adminRuntimeTablesGet(id),
    enabled: !!id,
  });
}

export function useAdminRuntimeTablesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminRuntimeTablesCreate']>[0]) => getClient().admin.adminRuntimeTablesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminRuntimeTablesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminRuntimeTablesUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminRuntimeTablesUpdate']>[1] }) => getClient().admin.adminRuntimeTablesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminRuntimeTablesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminRuntimeTablesDelete']>[0]) => getClient().admin.adminRuntimeTablesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminRuntimePagesList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'runtime-pages', options ?? {}],
    queryFn: () => getClient().admin.adminRuntimePagesList(options).then((r) => r.runtime_pages),
  });
}

export function useAdminRuntimePagesGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'runtime-pages', id],
    queryFn: () => getClient().admin.adminRuntimePagesGet(id),
    enabled: !!id,
  });
}

export function useAdminRuntimePagesCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminRuntimePagesCreate']>[0]) => getClient().admin.adminRuntimePagesCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminRuntimePagesUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminRuntimePagesUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminRuntimePagesUpdate']>[1] }) => getClient().admin.adminRuntimePagesUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminRuntimePagesDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminRuntimePagesDelete']>[0]) => getClient().admin.adminRuntimePagesDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminPlatformConfigList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'platform-config', options ?? {}],
    queryFn: () => getClient().admin.adminPlatformConfigList(options).then((r) => r.platform_config),
  });
}

export function useAdminPlatformConfigGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'platform-config', id],
    queryFn: () => getClient().admin.adminPlatformConfigGet(id),
    enabled: !!id,
  });
}

export function useAdminPlatformConfigCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminPlatformConfigCreate']>[0]) => getClient().admin.adminPlatformConfigCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminPlatformConfigUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminPlatformConfigUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminPlatformConfigUpdate']>[1] }) => getClient().admin.adminPlatformConfigUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminPlatformConfigDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminPlatformConfigDelete']>[0]) => getClient().admin.adminPlatformConfigDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminPlatformSecretsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'platform-secrets', options ?? {}],
    queryFn: () => getClient().admin.adminPlatformSecretsList(options).then((r) => r.platform_secrets),
  });
}

export function useAdminPlatformSecretsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'platform-secrets', id],
    queryFn: () => getClient().admin.adminPlatformSecretsGet(id),
    enabled: !!id,
  });
}

export function useAdminPlatformSecretsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminPlatformSecretsCreate']>[0]) => getClient().admin.adminPlatformSecretsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminPlatformSecretsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminPlatformSecretsUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminPlatformSecretsUpdate']>[1] }) => getClient().admin.adminPlatformSecretsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useAdminPlatformSecretsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['admin']['adminPlatformSecretsDelete']>[0]) => getClient().admin.adminPlatformSecretsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useTenantSecretsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['secrets', options ?? {}],
    queryFn: () => getClient().core.tenantSecretsList(options).then((r) => r.tenant_secrets),
  });
}

export function useTenantSecretsGet(id: string) {
  return useQuery({
    queryKey: ['secrets', id],
    queryFn: () => getClient().core.tenantSecretsGet(id),
    enabled: !!id,
  });
}

export function useTenantSecretsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['tenantSecretsCreate']>[0]) => getClient().core.tenantSecretsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useTenantSecretsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['core']['tenantSecretsUpdate']>[0]; request: Parameters<InferrexClient['core']['tenantSecretsUpdate']>[1] }) => getClient().core.tenantSecretsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useTenantSecretsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['core']['tenantSecretsDelete']>[0]) => getClient().core.tenantSecretsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['core'] });
    },
  });
}

export function useSupportTicketsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['portal', 'support-tickets', options ?? {}],
    queryFn: () => getClient().portal.supportTicketsList(options).then((r) => r.support_tickets),
  });
}

export function useSupportTicketsGet(id: string) {
  return useQuery({
    queryKey: ['portal', 'support-tickets', id],
    queryFn: () => getClient().portal.supportTicketsGet(id),
    enabled: !!id,
  });
}

export function useSupportTicketsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['portal']['supportTicketsCreate']>[0]) => getClient().portal.supportTicketsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['portal'] });
    },
  });
}

export function useSupportTicketsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['portal']['supportTicketsUpdate']>[0]; request: Parameters<InferrexClient['portal']['supportTicketsUpdate']>[1] }) => getClient().portal.supportTicketsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['portal'] });
    },
  });
}

export function useAdminSupportTicketsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['admin', 'support-tickets', options ?? {}],
    queryFn: () => getClient().admin.adminSupportTicketsList(options).then((r) => r.support_tickets),
  });
}

export function useAdminSupportTicketsGet(id: string) {
  return useQuery({
    queryKey: ['admin', 'support-tickets', id],
    queryFn: () => getClient().admin.adminSupportTicketsGet(id),
    enabled: !!id,
  });
}

export function useAdminSupportTicketsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['admin']['adminSupportTicketsUpdate']>[0]; request: Parameters<InferrexClient['admin']['adminSupportTicketsUpdate']>[1] }) => getClient().admin.adminSupportTicketsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['admin'] });
    },
  });
}

export function useStackAnalysisList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['intelligence', 'stack-analysis', options ?? {}],
    queryFn: () => getClient().intelligence.stackAnalysisList(options).then((r) => r.stack_analysis),
  });
}

export function useStackAnalysisGet(id: string) {
  return useQuery({
    queryKey: ['intelligence', 'stack-analysis', id],
    queryFn: () => getClient().intelligence.stackAnalysisGet(id),
    enabled: !!id,
  });
}

export function useDataUtilisationAnalysisList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['intelligence', 'data-utilisation', options ?? {}],
    queryFn: () => getClient().intelligence.dataUtilisationAnalysisList(options).then((r) => r.data_utilisation_analysis),
  });
}

export function useDataUtilisationAnalysisGet(id: string) {
  return useQuery({
    queryKey: ['intelligence', 'data-utilisation', id],
    queryFn: () => getClient().intelligence.dataUtilisationAnalysisGet(id),
    enabled: !!id,
  });
}

export function useSchemaContractsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['intelligence', 'schema-contracts', options ?? {}],
    queryFn: () => getClient().intelligence.schemaContractsList(options).then((r) => r.schema_contracts),
  });
}

export function useSchemaContractsGet(id: string) {
  return useQuery({
    queryKey: ['intelligence', 'schema-contracts', id],
    queryFn: () => getClient().intelligence.schemaContractsGet(id),
    enabled: !!id,
  });
}

export function useSchemaContractsCreate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['intelligence']['schemaContractsCreate']>[0]) => getClient().intelligence.schemaContractsCreate(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['intelligence'] });
    },
  });
}

export function useSchemaContractsUpdate(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['intelligence']['schemaContractsUpdate']>[0]; request: Parameters<InferrexClient['intelligence']['schemaContractsUpdate']>[1] }) => getClient().intelligence.schemaContractsUpdate(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['intelligence'] });
    },
  });
}

export function useSchemaContractsDelete(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['intelligence']['schemaContractsDelete']>[0]) => getClient().intelligence.schemaContractsDelete(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['intelligence'] });
    },
  });
}

export function useMigrationsList(options?: Record<string, unknown>) {
  return useQuery({
    queryKey: ['intelligence', 'migrations', options ?? {}],
    queryFn: () => getClient().migration.migrationsList(options).then((r) => r.migrations),
  });
}

export function useMigrationsGet(id: string) {
  return useQuery({
    queryKey: ['intelligence', 'migrations', id],
    queryFn: () => getClient().migration.migrationsGet(id),
    enabled: !!id,
  });
}

export function useConnectCliSession(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['cli']['connectCliSession']>[0]) => getClient().cli.connectCliSession(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli'] });
    },
  });
}

export function useGetCliSessionStatus(id: string) {
  return useQuery({
    queryKey: ['cli', id, 'status'],
    queryFn: () => getClient().cli.getCliSessionStatus(id),
    enabled: !!id,
  });
}

export function useExecCliSessionCommand(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['cli']['execCliSessionCommand']>[0]; request: Parameters<InferrexClient['cli']['execCliSessionCommand']>[1] }) => getClient().cli.execCliSessionCommand(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli'] });
    },
  });
}

export function useEndCliSession(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['cli']['endCliSession']>[0]) => getClient().cli.endCliSession(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli'] });
    },
  });
}

export function useExtendCliSession(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['cli']['extendCliSession']>[0]) => getClient().cli.extendCliSession(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli'] });
    },
  });
}

export function useListCliBrowserRequests(id: string) {
  return useQuery({
    queryKey: ['cli', id, 'browser-requests'],
    queryFn: () => getClient().cli.listCliBrowserRequests(id),
    enabled: !!id,
  });
}

export function useRelayCliLoginCallback(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['cli']['relayCliLoginCallback']>[0]; request: Parameters<InferrexClient['cli']['relayCliLoginCallback']>[1] }) => getClient().cli.relayCliLoginCallback(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli'] });
    },
  });
}

export function useScanCliSession(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: Parameters<InferrexClient['cli']['scanCliSession']>[0]) => getClient().cli.scanCliSession(vars, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli'] });
    },
  });
}

export function useAddCliTokenCommand(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['cli']['addCliTokenCommand']>[0]; request: Parameters<InferrexClient['cli']['addCliTokenCommand']>[1] }) => getClient().cli.addCliTokenCommand(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli'] });
    },
  });
}

export function useCaptureCliCredential(requestOptions?: MutationRequestOptions) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: Parameters<InferrexClient['cli']['captureCliCredential']>[0]; request: Parameters<InferrexClient['cli']['captureCliCredential']>[1] }) => getClient().cli.captureCliCredential(vars.id, vars.request, { idempotencyKey: idempotencyKeyFor(requestOptions) }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cli'] });
    },
  });
}
